import { render, staticRenderFns } from "./DestinationIcon.vue?vue&type=template&id=a551106a&"
import script from "./DestinationIcon.vue?vue&type=script&lang=js&"
export * from "./DestinationIcon.vue?vue&type=script&lang=js&"
import style0 from "./DestinationIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports